module.exports = __webpack_public_path__ + "img/flounce_width.7ccdb52b.png";